import {Flex} from 'antd';
import React from 'react'
import {useNavigate} from 'react-router-dom';
import pipLogo from '../assets/whiteLogo.png'

function RegistrationReference() {
    const navigate = useNavigate()
    const redirect = (key) => {
        switch(key) {
            case 'CONTRACT':
                navigate(`/leads?wlid=67ff684b4eb57fab4b82bbe4`)
                break;
            case 'WL':
                navigate('/wl-registration')
                break;

            default:
                break;
        }
    }
    return (
        <div className='ref-wrapper'>
            <div className='ref-content-block'>
                <Flex style={{marginBottom: 20}} justify='center'>
                    <img src={pipLogo} style={{width: '200px'}} />
                </Flex>
                <h2>CHOOSE YOUR FOREX FLIGHT PLAN</h2>
                <p>Welcome to Pip Pilots, a leading software provider for Forex accounts. 
                <br /> Which option best suits your needs? Please select below to get started!</p>
                <div className='block-wrapper'>
                    <div className='block' onClick={() => redirect('CONTRACT')}>
                    Contract-Based Partnership
                    </div>
                    <div className='block' onClick={() => redirect('WL')}>
                    White Label Partnership
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RegistrationReference